export const RefreshIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16.857'
      height='16.857'
      viewBox='0 0 16.857 16.857'
    >
      <path
        id='Path_50240'
        data-name='Path 50240'
        d='M48.255,38.02a.6.6,0,0,0,.6-.6V32.6a.6.6,0,0,0-1.2,0v3.484a8.427,8.427,0,1,0-.087,8.827.574.574,0,0,0-.515-.873.666.666,0,0,0-.553.309,7.225,7.225,0,1,1,.188-7.533H43.439a.6.6,0,0,0,0,1.2Z'
        transform='translate(-32 -32)'
        fill='#0153ff'
      />
    </svg>
  );
};
